module.exports = require('./lib/Observable.js').Observable;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/zen-observable/index.js
// module id = QbjI
// module chunks = 0